import type { FC } from 'react';
import { Flex, Modal, Spin, Typography } from 'antd';
import type { IDocumentModalProps } from 'client-app/components/documents/documents-modal/types.ts';
import styles from './documents-modal.module.scss';

export const DocumentsModal: FC<IDocumentModalProps> = ({
  onClose,
  isModalOpen,
  isLoading,
  documentsAvailable,
  children,
  title,
}) => {
  const renderModalContent = () => {
    if (isLoading) {
      return (
        <Flex justify='center' align='center' className={styles.noDocumentsAndLoaderWrapper} vertical>
          <Spin size='large' />
        </Flex>
      );
    }

    if (!documentsAvailable) {
      return (
        <Flex justify='center' align='center' className={styles.noDocumentsAndLoaderWrapper} vertical>
          <Typography.Text type='secondary'>No documents were found.</Typography.Text>
        </Flex>
      );
    }

    return children;
  };

  return (
    <Modal className={styles.modal} title={title} open={isModalOpen} footer={null} onCancel={onClose}>
      {renderModalContent()}
    </Modal>
  );
};
